import { DictionaryEvidence, TableColumn } from '@eas/common-web';
import { Certificate } from '@models';

export function useColumns(): TableColumn<Certificate>[] {
  const {
    columnName,
    columnActive,
    columnCode,
    columnCreated,
    columnCreatedBy,
  } = DictionaryEvidence.useDictionaryColumns<Certificate>();

  return [columnName, columnActive, columnCode, columnCreated, columnCreatedBy];
}
